<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" :title="title">
          <div slot="content">
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorCompany ? 'has-error' : ''">
              <label>Công ty<span class="error-symbol"></span></label>
              <multiselect v-model="selectedCompany" id="ajax1" label="name" track-by="code"
                           placeholder="Nhập để tìm công ty..."
                           :isRequire="errorCompany"
                           open-direction="bottom" :options="companies" :multiple="false" :searchable="true"
                           :loading="loadingCompany" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                           :disabled="disableCompanyField"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceCompany">
              </multiselect>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorDepartment ? 'has-error' : ''">
              <label>Phòng ban<span class="error-symbol"></span></label>
              <multiselect v-model="selectedDepartment" id="ajax2" label="name" track-by="code"
                           placeholder="Nhập để tìm phòng ban..."
                           :isRequire="errorDepartment"
                           open-direction="bottom" :options="departments" :multiple="false" :searchable="true"
                           :loading="loadingDepartment" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                           :disabled="disableDepartmentField"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceDepartment">
                <span slot="noResult">Không tìm thấy kết quả nào.</span>
              </multiselect>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorRoleName ? 'has-error' : ''">
              <label>Chức vụ<span class="error-symbol"></span></label>
              <input type="text" class="form-control" v-model="role.role_name" placeholder="Nhập chức vụ ..."/>
            </div>

            <div class="form-group col-md-12 col-sm-12 col-xs-12">
              <label>Quyền đọc</label>
              <multiselect v-model="selectedReadPermissions" tag-placeholder="Thêm quyền đọc mới"
                           placeholder="Tìm kiếm và thêm quyền đọc" label="name" track-by="code"
                           :options="readPermissions" :multiple="true" :close-on-select="false">
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="selectedEditPermissions.length"
                       @mousedown.prevent.stop="clearAllReadPermissions(props.search)"></div>
                </template>
                <span slot="noResult">Không tìm thấy kết quả nào</span>
              </multiselect>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12">
              <label>Quyền ghi</label>
              <multiselect v-model="selectedEditPermissions" tag-placeholder="Thêm quyền ghi mới"
                           placeholder="Tìm kiếm và thêm quyền ghi" label="name" track-by="code"
                           :options="editPermissions" :multiple="true" :close-on-select="false">
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="selectedEditPermissions.length"
                       @mousedown.prevent.stop="clearAllEditPermissions(props.search)"></div>
                </template>
                <span slot="noResult">Không tìm thấy kết quả nào</span>
              </multiselect>
            </div>
          </div>
          <div slot="footer">
            <div class="pull-right">
              <b-button variant="success" class="w-100px" @click="save" :disabled="!isEditable">Lưu</b-button>
              <b-button variant="warning" class="w-100px" @click="back">Trờ về</b-button>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import RoleAPI from '../../../api/role'
import Utils from '../../../common/utils'
import Multiselect from '../../../lib/vue-multiple-select/Multiselect'
import CompanyAPI from '../../../api/company'
import DepartmentAPI from '../../../api/department'
import {debounce} from 'lodash'
import {mapGetters} from 'vuex'
import {Constant, PERMISSION_KEY} from '../../../common/constant'
import PermissionAPI from '../../../api/permission'

export default {
  name: 'RoleDetail',
  components: {
    'va-box': VABox,
    Multiselect
  },
  data () {
    return {
      role: {
        id: null,
        company_id: '',
        department_id: '',
        role_name: '',
      },
      click: false,
      loading: false,
      saving: false,
      loadingCompany: false,
      companies: [],
      loadingDepartment: false,
      departments: [],
      selectedCompany: null,
      selectedDepartment: null,
      debounceCompany: null,
      debounceDepartment: null,
      disableCompanyField: false,
      disableDepartmentField: false,
      isEditable: true,
      title: '',
      selectedEditPermissions: [],
      selectedReadPermissions: [],
      editPermissions: Constant.PERMISSION_LIST,
      readPermissions: Constant.PERMISSION_LIST,
      permission: {
        id: null,
        company_id: '',
        department_id: '',
        role_id: '',
        permission_id: null,
        edit_permissions: [],
        read_permissions: [],
      }
    }
  },

  created () {
    this.debounceCompany = debounce(this.filterCompany.bind(this), 500)
    this.debounceDepartment = debounce(this.filterDepartment.bind(this), 500)
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorCompany () {
      return this.click && (this.selectedCompany == null || this.selectedCompany.length === 0)
    },
    errorDepartment () {
      return this.click && (this.selectedDepartment == null || this.selectedDepartment.length === 0)
    },
    errorRoleName () {
      return this.isEmpty(this.role.role_name)
    }
  },
  mounted () {
    this.disableCompanyField = this.isEdit()
    this.disableDepartmentField = this.isEdit()
    this.initCompany()
    this.init()
    this.filterDepartment()
    this.isEditable = this.hasEditPermission()
    this.title = this.isEdit() ? 'Cập nhật chức vụ' : 'Thêm chức vụ mới'
    if (this.userInfo && !this.userInfo.phone_number) {
      this.editPermissions = this.editPermissions.filter(item => (item.code !== PERMISSION_KEY.PHONE_NUMBER_ADMIN && item.code !== PERMISSION_KEY.PHONE_NUMBER_MANAGER && item.code !== PERMISSION_KEY.PHONE_NUMBER_TECHNICAL))
      this.readPermissions = this.readPermissions.filter(item => (item.code !== PERMISSION_KEY.PHONE_NUMBER_ADMIN && item.code !== PERMISSION_KEY.PHONE_NUMBER_MANAGER && item.code !== PERMISSION_KEY.PHONE_NUMBER_TECHNICAL))
    }
  },
  methods: {
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.USER_MANAGEMENT)
    },
    initCompany () {
      let company = Utils.getCompanyByUserInfo(this.userInfo)
      if (company) {
        this.disableCompanyField = true
        this.selectedCompany = {name: company.name, code: company.id}
      }
    },
    isEdit () {
      return !!this.$route.params.id
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    init () {
      this.getRoleDetail()
    },
    async getRoleDetail () {
      this.loading = true
      const id = this.$route.params.id
      if (id) {
        try {
          this.role = (await RoleAPI.findById(id)).data.data
          this.selectedCompany = {
            code: this.role.company_id,
            name: this.role.company_name
          }
          this.selectedDepartment = {
            code: this.role.department_id,
            name: this.role.department_name
          }
          this.loading = false
          this.getPermissionDetail()
        } catch (err) {
          Utils.handleError(this.$bvToast, err)
          this.loading = false
        }
      }
      return null
    },
    async getPermissionDetail () {
      this.loading = true
      try {
        const filterData = {
          company_id: this.role.company_id,
          department_id: this.role.department_id,
          role_id: this.role.id
        }

        const permissions = (await PermissionAPI.filter(filterData, 0, 1)).data.data.records

        if (permissions && permissions.length > 0) {
          this.permission = permissions[0]
          this.selectedReadPermissions = this.permission.read_permissions.map(item => {
            const name = Constant.PERMISSION_LIST.filter(permission => permission.code === item)[0].name
            return {code: item, name: name}
          })
          this.selectedEditPermissions = this.permission.edit_permissions.map(item => {
            const name = Constant.PERMISSION_LIST.filter(permission => permission.code === item)[0].name
            return {code: item, name: name}
          })

          if (this.userInfo && !this.userInfo.phone_number) {
            this.selectedReadPermissions = this.selectedReadPermissions.filter(item => (item.code !== PERMISSION_KEY.PHONE_NUMBER_ADMIN && item.code !== PERMISSION_KEY.PHONE_NUMBER_MANAGER && item.code !== PERMISSION_KEY.PHONE_NUMBER_TECHNICAL))
            this.selectedEditPermissions = this.selectedEditPermissions.filter(item => (item.code !== PERMISSION_KEY.PHONE_NUMBER_ADMIN && item.code !== PERMISSION_KEY.PHONE_NUMBER_MANAGER && item.code !== PERMISSION_KEY.PHONE_NUMBER_TECHNICAL))
          }
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      }
    },
    filterCompany (query) {
      this.loadingCompany = true
      CompanyAPI.findByName(query, 0, 20).then(res => {
        this.companies = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingCompany = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingCompany = false
      })
    },
    filterDepartment (query) {
      this.loadingDepartment = true
      if (this.selectedCompany == null) {
        this.loadingCompany = false
        return
      }
      const filterData = {
        company_id: this.selectedCompany.code,
        department_name: query
      }
      DepartmentAPI.filter(filterData, 0, 20).then(res => {
        this.departments = res.data.data.records.map(item => {
          return {'name': item.department_name, 'code': item.id}
        })
        this.loadingDepartment = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingDepartment = false
      })
    },
    back () {
      if (this.selectedCompany) {
        this.$router.push({
          name: 'RoleList',
          query: {company_id: this.selectedCompany.code}
        })
      } else {
        this.$router.push({name: 'RoleList'})
      }
    },
    validate () {
      return !this.errorDepartment && !this.errorCompany && !this.errorRoleName
    },
    validatePermission () {
      let editPermissions = this.selectedEditPermissions.map(item => item.code)
      if (editPermissions.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE) && editPermissions.includes(PERMISSION_KEY.DATA_MANAGEMENT)) {
        return false
      }

      let readPermissions = this.selectedReadPermissions.map(item => item.code)
      if (readPermissions.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE) && readPermissions.includes(PERMISSION_KEY.DATA_MANAGEMENT)) {
        return false
      }

      return true
    },
    save () {
      this.click = true
      this.saving = true
      this.loading = true
      if (!this.validate()) {
        this.saving = false
        this.loading = false
        return
      }
      if (!this.validatePermission()) {
        Utils.failedToast(this.$bvToast, 'Lỗi xảy ra', 'Không được chọn cùng quyền "Quản lý data" và "Quản lý data cho sale"')
        this.saving = false
        this.loading = false
        return
      }

      const id = this.$route.params.id
      if (id) {
        this.role.company_id = this.selectedCompany.code
        this.role.company_name = this.selectedCompany.name
        this.role.department_id = this.selectedDepartment.code
        this.role.department_name = this.selectedDepartment.name
        RoleAPI.update(this.role).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            this.buildPermission(res.data.data.id)
            PermissionAPI.update(this.permission).then(res => {
              if (res != null && res.data != null) {
                Utils.successToast(this.$bvToast)
              }
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        if (this.role.company_id === null || this.role.company_id === '') {
          this.role.company_id = this.selectedCompany.code
        }
        if (this.role.department_id === null || this.role.department_id === '') {
          this.role.department_id = this.selectedDepartment.code
        }
        RoleAPI.create(this.role).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            this.buildPermission(res.data.data.id)
            PermissionAPI.create(this.permission).then(res => {
              if (res != null && res.data != null) {
                Utils.successToast(this.$bvToast)
                this.back()
              }
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    buildPermission (role_id) {
      this.permission.company_id = this.selectedCompany.code
      this.permission.department_id = this.selectedDepartment.code
      this.permission.role_id = role_id
      this.permission.edit_permissions = this.selectedEditPermissions.map(item => item.code)
      this.permission.read_permissions = this.selectedReadPermissions.map(item => item.code)
    },
    clearAllReadPermissions () {
      this.selectedReadPermissions = []
    },
    clearAllEditPermissions () {
      this.selectedEditPermissions = []
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/role/RoleDetail.vue